import React from "react";
import BirthdayAnimation from "./animation/BirthdayAnimation";
import BalloonAnimation from "./animation/BalloonAnimation"; // Import the BalloonAnimation component
import ConfettiAnimation from './animation/ConfettiAnimation'; // Import the ConfettiAnimation component

const HeroSection = ({ title, subtitle, image }) => {
    return (
        <section className="hero">
            <img src={image} alt="Hero" className="hero-image" />
            <h1>{title}</h1>
            <p>{subtitle}</p>

            <BirthdayAnimation /> {/* Birthday animation */}
            {/*<BalloonAnimation />   /!* Single balloon animation *!/*/}
            <ConfettiAnimation /> {/* Confetti animation */}
        </section>
    );
};

export default HeroSection;
